const data: any = [
  {
    quarter: "Q4 2021",
    events: [
      "CPS Proposal Approved by ICON P-Reps",
      "GangstaBet minting started",
      "Sold out in less than a week!",
      "$CROWN announcement and reward distribution to LP providers begins",
    ],
  },
  {
    quarter: "Q1 2022",
    events: ["The Emerald City announcemennt", "GangstaBet Stories"],
  },
  {
    quarter: "Q2 2022",
    events: [
      "GOLDEN Keys release",
      "$CROWN Launch",
      "Released and Airdropped Bribe Token",
      "Bank in Emerald City launch",
    ],
  },
  {
    quarter: "Q3 2022",
    events: [
      "Land Ownership Certificates (LOC) public sale and sold out in 40 hours",
      "The Emerald City trailer launch",
      "The Emerald City map reveal",
    ],
  },
  {
    quarter: "Q4 2022",
    events: [
      "GangstaBet rebrand to GangstaVerse",
      "Launch of GangstaVerseDAO",
      "GangstaBet Illustration public sale",
    ],
  },
  {
    quarter: "Q1 2023",
    events: [
      "FOREX Launch",
      "GangtaVerse: Mini-Games",
      "GangstaVerse: Gangwars",
    ],
  },
  {
    quarter: "Q2 2023",
    events: [
      "LAND public sale",
      "The Emerald City map full launch",
      "GangstaVerse Merch store",
    ],
  },
  {
    quarter: "To be revealed soon",
    events: [],
  },
];

export { data };
